const fmt = (min, max) => new Intl.NumberFormat("it-IT", { minimumFractionDigits: min, maximumFractionDigits: max });
const cache = {};

// Valori importati come stringhe decimali: nessun arrotondamento oltre la precisione salvata
export const dec = (v, min = 2, max = 4) => {
  if (v === null || v === undefined || v === "") return "—";
  const k = `${min}-${max}`;
  cache[k] = cache[k] || fmt(min, max);
  return cache[k].format(Number(v));
};

export const eur = (v, max = 2) => (v === null || v === undefined ? "—" : `€ ${dec(v, 2, max)}`);

export const STATO_ANALISI = {
  reale: { label: "Analisi reale", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  adattata: { label: "Analisi adattata", cls: "bg-teal-50 text-teal-800 border-teal-200" },
  stima: { label: "Stima senza analisi", cls: "bg-amber-50 text-amber-800 border-amber-200" },
};

export const pill = "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap";

export const fmtData = (iso) => new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" });
